import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PublicCatalogItem } from '../models/catalogs/public-catalog';
import { Observable } from 'rxjs';
import { Paged } from '../models/shared/paged';
import { HttpUtil } from '../utils/http-util';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicCatalogService {

  constructor(
    private _http: HttpClient
  ) { }


  getPublicCatalog(
    page: number = 1,
    pageSize: number = 20,
    eligibilityFilter?: string,
    functionalTypeFilter?: number
  ): Observable<Paged<PublicCatalogItem>> {
    return this._http.get<Paged<PublicCatalogItem>>(`${environment.api.url}/PublicCatalog`, {
      params: HttpUtil.toHttpParams({
        page: page,
        pageSize: pageSize,
        eligibilityFilter: eligibilityFilter,
        functionalTypeFilter: functionalTypeFilter
      })
    });
  }

}
